export default {
  data() {
    return {
      booksList: this.books,
      childrenBooksList: this.childrenBooks,
    };
  },
  watch: {
    books() {
      this.booksList = this.books;
    },
    childrenBooks() {
      this.childrenBooksList = this.childrenBooks;
    },
  },
  computed: {
    flatChildrenBooks() {
      let books = [];
      if (this.childrenBooksList) {
        // eslint-disable-next-line no-restricted-syntax
        for (const child in this.childrenBooksList) {
          if (Object.prototype.hasOwnProperty.call(this.childrenBooksList, child))
            books = books.concat(this.childrenBooksList[child]);
        }
      }
      return books;
    },
  },
};
